import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient.js';
import UnitDetails from './UnitDetails';

export default function UnitsList() {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUnit, setSelectedUnit] = useState(null);

  useEffect(() => {
    fetchUnits();
  }, []);

  async function fetchUnits() {
    setLoading(true);

    const { data, error } = await supabase.from('units').select(`
        serial_number,
        organizations!units_current_owner_org_id_fkey(name)
      `);

    if (error) {
      console.error('Error fetching units:', error);
    } else {
      setUnits(data);
    }

    setLoading(false);
  }

  // 👉 SHOW DETAILS SCREEN
  if (selectedUnit) {
    return (
      <UnitDetails
        serialNumber={selectedUnit}
        onBack={() => setSelectedUnit(null)}
      />
    );
  }

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial' }}>
      <h2 style={{ marginBottom: '20px' }}>📦 Cartons List</h2>

      {loading && <p>Loading...</p>}

      {!loading && units.length === 0 && <p>No cartons found</p>}

      {!loading &&
        units.map((unit, index) => (
          <div
            key={index}
            onClick={() => setSelectedUnit(unit.serial_number)}
            style={{
              border: '1px solid #ddd',
              borderRadius: '8px',
              padding: '15px',
              marginBottom: '12px',
              background: '#f9f9f9',
              cursor: 'pointer',
              transition: '0.2s',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = '#f1f1f1')}
            onMouseLeave={(e) => (e.currentTarget.style.background = '#f9f9f9')}
          >
            <h3 style={{ margin: '0 0 8px 0' }}>{unit.serial_number}</h3>

            <p style={{ margin: 0 }}>
              <strong>Owner:</strong> {unit.organizations?.name || 'Unknown'}
            </p>
          </div>
        ))}
    </div>
  );
}
